import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SidebarState } from "./types";
import { SidebarType } from "../config";

const initialState: SidebarState = {
    type: "default"
}

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setSidebarType: (state, action: PayloadAction<SidebarType>) => {
            state.type = action.payload
        }
    }
})

export default sidebarSlice.reducer
export const { setSidebarType } = sidebarSlice.actions